import { TablePagination } from '@/components/sv/table-pagination'
import type { Table } from '@tanstack/react-table'

type Props = {
  table: Table<any>
}

export const TableFrontendPagination = ({ table }: Props) => {
  return (
    <TablePagination
      pageCount={table.getPageCount()}
      currentPage={table.getState().pagination.pageIndex + 1}
      pageSize={table.getState().pagination.pageSize}
      setPageSize={table.setPageSize}
      canPreviousPage={table.getCanPreviousPage()}
      canNextPage={table.getCanNextPage()}
      firstPage={table.firstPage}
      previousPage={table.previousPage}
      nextPage={table.nextPage}
      lastPage={table.lastPage}
    />
  )
}
